/**
 * Rule Form Validation Utility
 *
 * Validates rule form data and returns validation results
 */

/**
 * Validate rule form data
 * @param {Object} formData - The form data to validate
 * @returns {Object} - { isValid: boolean, errors: Object }
 */
export const validateRuleForm = (formData) => {
  const errors = {};

  // Rule name validation
  if (!formData.name || formData.name.trim() === '') {
    errors.name = 'Rule name is required';
  } else if (formData.name.length > 255) {
    errors.name = 'Rule name must be less than 255 characters';
  }

  // Team validation
  if (!formData.team || formData.team.trim() === '') {
    errors.team = 'Team is required';
  }

  // Target category validation
  if (!formData.categoryId && (!formData.targetCategory || formData.targetCategory.trim() === '')) {
    errors.targetCategory = 'Target category is required';
  } else if (formData.targetCategory && formData.targetCategory.length > 255) {
    errors.targetCategory = 'Target category must be less than 255 characters';
  }

  // Conditions validation
  if (!formData.conditions || formData.conditions.length === 0) {
    errors.conditions = 'At least one condition is required';
  } else {
    formData.conditions.forEach((condition, index) => {
      if (!condition.field) {
        errors[`condition_${index}_field`] = 'Field is required';
      }
      if (!condition.operator) {
        errors[`condition_${index}_operator`] = 'Operator is required';
      }
      if (!condition.value || condition.value.trim() === '') {
        errors[`condition_${index}_value`] = 'Value is required';
      }
    });
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

/**
 * Validate individual condition
 * @param {Object} condition - The condition to validate
 * @returns {Object} - { isValid: boolean, errors: Object }
 */
export const validateCondition = (condition) => {
  const errors = {};

  if (!condition.field) {
    errors.field = 'Field is required';
  }

  if (!condition.operator) {
    errors.operator = 'Operator is required';
  }

  if (!condition.value || condition.value.trim() === '') {
    errors.value = 'Value is required';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

